<template>
	<div class="ph-item m-d-16 p-0">
		<div class="ph-col-12 p-0">
			<div class="ph-row m-0">
				<div class="ph-col-12 big m-0"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOFilterSelectSkeleton",
}
</script>

<style>
.ph-item {
	border: none;
}
</style>